require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-rwanda-stunting-prevention-and-reduction-project.json") })
        }
      }, "path---en-us-project-rwanda-stunting-prevention-and-reduction-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-rwanda-stunting-prevention-and-reduction-project!./.cache/json/en-us-project-rwanda-stunting-prevention-and-reduction-project.json
// module id = 559
// module chunks = 231608221292675